import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f0a3d1d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
import router from '@/router';
export default {
  __name: 'index',
  props: {
    abilityData: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const onButton = item => {
      router.push({
        path: '/course',
        query: {
          name: item.name
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.abilityData, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "block",
          key: item
        }, [_createVNode(_component_el_button, {
          text: "",
          class: "ability",
          onClick: $event => onButton(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128))]);
    };
  }
};